import React from "react";
import "./Footer.css";
import fbIcon from "../../assets/images/facebook.png";
import twitterIcon from "../../assets/images/twitter.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bar">
        <p className="footer-copy">
          Copyright &copy; 2013 vsjewelcast, Vadodara, Gujarat, India. All rights
          reserved.
        </p>

        <div className="footer-social" aria-label="Social links">
          <a href="https://www.facebook.com/vsjewelcast" target="_blank" rel="noreferrer">
            <img src={fbIcon} alt="Facebook" className="footer-social-icon" />
          </a>
          <a href="https://x.com/vsjewelcast" target="_blank" rel="noreferrer" aria-label="Twitter">
            <img src={twitterIcon} alt="Twitter" className="footer-social-icon" />
          </a>
        </div>

        <p className="footer-powered">Powered By : Barodaweb The E-Catalogue Designer.</p>
      </div>
    </footer>
  );
}
